const InfoCircleIcon = ({ className = "text-[#555] dark:text-[#FAFAFA]" }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    aria-hidden
    className={className}
  >
    <circle cx="6.5" cy="6.5" r="5.5" stroke="currentColor" strokeWidth="1" />
    <path
      d="M6.5 6V9"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <circle cx="6.5" cy="4.25" r="0.75" fill="currentColor" />
  </svg>
);

export default InfoCircleIcon;
